import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Col, Row,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import SettingsEditButtons from '../../../EditButtons';
import SettingsItemsWrapper from '../../../Item/ItemsWrapper';

const SettingsMetadataContent = (props) => {
  const {
    saving, handleSave, unsaved,
  } = props;

  const intl = useIntl();

  return (
    <>
      <div className="settings-inner-content">
        <Row>
          <Col>
            <h3>{intl.formatMessage({ defaultMessage: 'IPTC' })}</h3>
          </Col>
        </Row>
        <SettingsItemsWrapper
          {...props}
        />
      </div>
      <SettingsEditButtons
        saving={saving}
        handleSave={handleSave}
        unsaved={unsaved}
      />
    </>
  );
};

const mapStateToProps = state => ({
  clientSettings: state.App.settings,
});

SettingsMetadataContent.propTypes = {
  saving: PropTypes.bool.isRequired,
  handleSettingChange: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  unsaved: PropTypes.bool.isRequired,
  settings: PropTypes.object.isRequired,
  clientSettings: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(SettingsMetadataContent);
